<template>
  <div>
    <div class="ts-h-screen">
      <div class="h-100">
        <!-- BEGIN pos -->
        <div
          class="pos pos-customer"
          v-bind:class="{ 'pos-mobile-sidebar-toggled': posMobileSidebar }"
          id="pos-customer"
        >
          <!-- BEGIN pos-menu -->
          <div class="pos-menu">
            <a
              href="#"
              @click.prevent="$router.push({ name: 'mart-sale-list' })"
            >
              <div class="logo">
                <div class="logo-img">
                  <img
                    v-lazy="{
                      src: companyLogo,
                      error: require('@/assets/logo.png')
                    }"
                  />
                </div>
                <!-- <div class="logo-text">Pine & Dine</div> -->
              </div>
            </a>
            <div class="nav-container overflow-auto">
              <div
                data-scrollbar="true"
                data-height="100%"
                data-skip-mobile="true"
              >
                <ts-tabs-horizontal target="gTab">
                  <ts-tab-horizontal @click="onChangeCategory">
                    <i class="fas fa-star fa-2x fa-fw"></i>
                    {{ $t('martSale.top20Sale') }}
                  </ts-tab-horizontal>
                  <ts-tab-horizontal
                    v-for="(c, index) in productCategory"
                    @click="onChangeCategory(c.category_id)"
                    :key="index"
                  >
                    <i :class="c.icon" class="fa-2x fa-fw"></i>
                    {{ locale == 'kh' ? c.category_name_kh : c.category_name_en }}
                  </ts-tab-horizontal>
                </ts-tabs-horizontal>
              </div>
            </div>
            <div class="pos-sidebar-footer pos-sidebar-footer-time ts-whitespace-no-wrap">
              <h4 class="time text-center">{{ currentTime }}</h4>
              <div><i class="far fa-calendar-alt"></i> {{ currentDate }}</div>
              <div>
                <i class="fas fa-user"></i>
                {{ $store.state.authUser.user.name }}
              </div>
              <div>
                FX
                {{ exchangeRate + ' ' + toCurrency }}
              </div>
            </div>
          </div>
          <!-- END pos-menu -->

          <!-- BEGIN pos-content -->
          <div class="pos-content" data-scrollbar="true">
            <div
              class="ts-sticky ts-top-0 ts-z-50 ts-shadow-md sub-group"
              style="background: #f2f3f4;"
            >
              <div class="row">
                <div class="col-lg-9">
                  <a-tabs
                    v-if="subCategories.length > 0"
                    v-model="activeKey"
                    :tab-position="mode"
                    :style="{ background: '#f2f3f4' }"
                    @prevClick="callback"
                    @nextClick="callback"
                    class="ts-sticky ts-top-0 ts-z-50 kh-font"
                  >
                    <a-tab-pane
                      v-for="c in subCategories"
                      :key="c.pro_group_id"
                      class="kh-font"
                    >
                      <span slot="tab">
                        <i :class="c.icon" class="fa-fw"></i>
                        {{ locale == 'kh' ? c.pro_group_name_kh : c.pro_group_name_en }}
                      </span>
                    </a-tab-pane>
                  </a-tabs>
                  <a-tabs
                    v-if="categories.length > 0"
                    v-model="activeKeyCategory"
                    :tab-position="mode"
                    :style="{ background: '#f2f3f4' }"
                    @prevClick="callback"
                    @nextClick="callback"
                    class="ts-sticky ts-top-0 ts-z-50 kh-font"
                  >
                    <a-tab-pane
                      v-for="c in categories"
                      :key="c.category_id"
                      class="kh-font"
                    >
                      <span slot="tab">
                        <i :class="c.icon" class="fa-fw"></i>
                        {{ locale == 'kh' ? c.category_name_kh : c.category_name_en }}
                      </span>
                    </a-tab-pane>
                  </a-tabs>
                </div>
                <div class="col-lg-3">
                  <div class="search-box">
                    <SearchBox
                      v-model="fetchOptions"
                      @onEnter="searchBarcode"
                    />
                  </div>
                </div>
              </div>
            </div>
            <ts-loading-banner :loading="productFetching">
              <ts-tab-panes-horizontal name="gTab">
                <ts-tab-pane-horizontal>
                  <div
                    class="product-container"
                    v-for="(pro, index) in products"
                    :key="index"
                  >
                    <div>
                      <a
                        class="btn btn-xs btn-block btn-info ts-z-40 rounded-0"
                        style="margin-bottom: -21px; position: relative;"
                        v-b-modal.modalPosItem
                        @click.prevent="selectProduct(pro.product_id)"
                        >{{ $t('martSale.details') }}</a
                      >
                      <a
                        href="#"
                        class="product"
                        @click.prevent="addProduct(pro.product_id)"
                      >
                        <img
                          class="img"
                          v-lazy="{
                            src: pro.photo
                              ? pro.photo
                              : require('@/assets/default-product.jpg'),
                            error: require('@/assets/default-product.jpg')
                            // loading: require('@/assets/Rolling-1s-200px_2.svg')
                          }"
                        />
                        <div class="in-stock-container">
                          <span class="in-stock-card">In stock: {{ pro.current_stock }}</span>
                        </div>
                        <div class="text">
                          <div class="title ts-whitespace-no-wrap">
                            {{
                              pro.product_name_kh
                                ? pro.product_name_kh
                                : pro.product_name_en
                            }}
                          </div>
                          <div class="desc ts-whitespace-no-wrap">
                            {{ pro.product_name_en }}
                          </div>
                          <div class="desc ts-whitespace-no-wrap text-warning">
                            {{ pro.storage_name_en ? 'Storage: ' + pro.storage_name_en : '' }}
                          </div>
                          <div class="price">
                            <span class="text-info">{{ pro.barcode }}</span>
                            <span class="pull-right ts-text-blue-600"
                              >{{ defaultCrrency }}
                              {{ defaultPrice(pro.product_id) }}</span
                            >
                          </div>
                        </div>
                        <div class="tag-container">
                          <span
                            v-if="getPromotionDiscount(pro.product_id)"
                            class="multi-tag"
                            >{{
                              getPromotionDiscount(pro.product_id)
                                .promo_discount_value
                            }}% {{ $t('martSale.discount') }}</span
                          >
                          <span
                            v-if="
                              getPromotionBuyItemFreeItem(
                                pro.product_id,
                                saleCodeByDefaultUom(pro.product_id)
                                  .unit_of_measure.uom_id
                              )
                            "
                            class="multi-tag"
                            >{{
                              getPromotionBuyItemFreeItem(
                                pro.product_id,
                                saleCodeByDefaultUom(pro.product_id)
                                  ? saleCodeByDefaultUom(pro.product_id)
                                      .unit_of_measure.uom_id
                                  : 0
                              ).promotion_name
                            }}</span
                          >
                        </div>
                      </a>
                    </div>
                  </div>
                </ts-tab-pane-horizontal>
                <ts-tab-pane-horizontal v-for="(c, index) in productCategory">
                  <div
                    class="product-container"
                    v-for="(pro, index) in products"
                    :key="index"
                  >
                    <div>
                      <a
                        class="btn btn-xs btn-block btn-info ts-z-40 rounded-0"
                        style="margin-bottom: -21px; position: relative;"
                        v-b-modal.modalPosItem
                        @click.prevent="selectProduct(pro.product_id)"
                        >{{ $t('martSale.details') }}</a
                      >
                      <a
                        href="#"
                        class="product"
                        @click.prevent="addProduct(pro.product_id)"
                      >
                        <img
                          class="img"
                          v-lazy="{
                            src: pro.photo
                              ? pro.photo
                              : require('@/assets/default-product.jpg'),
                            error: require('@/assets/default-product.jpg')
                            // loading: require('@/assets/Rolling-1s-200px_2.svg')
                          }"
                        />
                        <div class="in-stock-container">
                          <span class="in-stock-card">In stock: {{ pro.current_stock }}</span>
                        </div>
                        <div class="text">
                          <div class="title ts-whitespace-no-wrap">
                            {{
                              pro.product_name_kh
                                ? pro.product_name_kh
                                : pro.product_name_en
                            }}
                          </div>
                          <div class="desc ts-whitespace-no-wrap">
                            {{ pro.product_name_en }}
                          </div>
                          <div class="desc ts-whitespace-no-wrap text-warning">
                            {{ pro.storage_name_en ? 'Storage: ' + pro.storage_name_en : '' }}
                          </div>
                          <div class="price">
                            <span class="text-info">{{ pro.barcode }}</span>
                            <span class="pull-right ts-text-blue-600"
                              >{{ defaultCrrency }}
                              {{ defaultPrice(pro.product_id) }}</span
                            >
                          </div>
                          <div class="tag-container">
                            <span
                              v-if="getPromotionDiscount(pro.product_id)"
                              class="multi-tag"
                              >{{
                                getPromotionDiscount(pro.product_id)
                                  .promo_discount_value
                              }}% {{ $t('martSale.discount') }}</span
                            >
                            <span
                              v-if="
                                getPromotionBuyItemFreeItem(
                                  pro.product_id,
                                  saleCodeByDefaultUom(pro.product_id)
                                    .unit_of_measure.uom_id
                                )
                              "
                              class="multi-tag"
                              >{{
                                getPromotionBuyItemFreeItem(
                                  pro.product_id,
                                  saleCodeByDefaultUom(pro.product_id)
                                    ? saleCodeByDefaultUom(pro.product_id)
                                        .unit_of_measure.uom_id
                                    : 0
                                ).promotion_name
                              }}</span
                            >
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </ts-tab-pane-horizontal>
              </ts-tab-panes-horizontal>
            </ts-loading-banner>
          </div>
          <!-- END pos-content -->
          <!-- BEGIN pos-sidebar -->
          <div class="pos-sidebar" id="pos-sidebar">
            <div class="pos-sidebar-header">
              <div class="back-btn">
                <button
                  type="button"
                  v-on:click="posMobileSidebarToggled"
                  class="btn"
                >
                  <svg
                    viewBox="0 0 16 16"
                    class="bi bi-chevron-left"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </button>
              </div>
              <div class="icon ts-text-white">
                <i
                  v-if="dataSend.order_no"
                  class="fas fa-people-carry fa-2x"
                ></i>
                <ts-button
                  v-else
                  @click.prevent="() => (add_new_customer = true)"
                  v-tooltip="$t('martSale.addCustomer')"
                  color="info"
                >
                  <i class="fas fa-plus fa-2x"></i>
                </ts-button>
              </div>
              <div class="title">
                <ts-select-customer
                  v-if="!dataSend.order_no"
                  v-model="dataSend.customer_id"
                  :class="{ 'is-invalid': errors.has('customer_id') }"
                />
                <div
                  class="invalid-feedback ts-text-xs"
                  v-if="errors.has('customer_id') && !dataSend.order_no"
                >
                  {{ errors.first('customer_id') }}
                </div>
                <b v-if="dataSend.order_no" class="ts-text-white">{{
                  orderSelected.customer
                    ? orderSelected.customer.customer_name
                    : ''
                }}</b>
              </div>
              <div class="order" v-if="dataSend.order_no">
                {{ $t('martSale.order') }}: <b>#{{ dataSend.order_no }}</b>
              </div>
            </div>
            <div class="pos-sidebar-nav">
              <ts-tabs
                target="orderTab"
                @change="changeTab"
                v-model="activeTabKey"
              >
                <ts-tab :tabKey="0"
                  >{{ $t('martSale.newOrder') }} ({{
                    dataSend.products.length
                  }})</ts-tab
                >
                <ts-tab :tabKey="1"
                  >{{ $t('martSale.orderHistory') }} ({{
                    orderHistories.length
                  }})</ts-tab
                >
              </ts-tabs>
            </div>
            <ts-tab-panes
              name="orderTab"
              @tabchange="changeTab"
              v-model="activeTabKey"
            >
              <ts-tab-pane :tabKey="0">
                <ts-loading-banner :loading="addingToCart">
                  <div
                    class="pos-table"
                    v-if="dataSend.products.length > 0 && activeTabKey == 0"
                  >
                    <div
                      class="row pos-table-row"
                      v-for="(order, index) in dataSend.products"
                      :key="index"
                    >
                      <div class="col-9">
                        <div class="pos-product-thumb">
                          <div class="img ts-text-center">
                            <img
                              class="img"
                              v-lazy="{
                                src: getProduct(order.product_id).photo
                                  ? getProduct(order.product_id).photo
                                  : require('@/assets/default-product.jpg'),
                                error: require('@/assets/default-product.jpg'),
                                loading: require('@/assets/Rolling-1s-200px_2.svg')
                              }"
                            />
                            <span class="text-info ts-font-bold">
                              {{ getProduct(order.product_id).barcode }}
                            </span>
                            <span class="text-warning ts-whitespace-no-wrap ts-text-xs">
                              {{ getProduct(order.product_id).storage_name_en ? getProduct(order.product_id).storage_name_en : '' }}
                            </span>
                          </div>
                          <div class="info">
                            <div class="title">
                              {{
                                getProduct(order.product_id)
                                  ? getProduct(order.product_id).product_name_kh
                                    ? getProduct(order.product_id)
                                        .product_name_kh
                                    : getProduct(order.product_id)
                                        .product_name_en
                                  : ''
                              }}
                              <small>{{
                                order.remarks ? '(' + order.remarks + ')' : ''
                              }}</small>
                            </div>
                            <div class="single-price">
                              <span class="ts-text-blue-600"
                                >{{ defaultCrrency }}
                                {{ order.unit_price }}</span
                              >
                              - {{ $t('martSale.size') }}:
                              {{ getUomName(order.product_id, order.uom_id) }}
                            </div>
                            <div class="desc">
                              - {{ $t('martSale.discount') }}
                              {{
                                order.discount_rate
                                  ? '(' + order.discount_rate + '%)'
                                  : ''
                              }}:
                              <span class="text-warning"
                                >{{ defaultCrrency }}
                                {{ order.discount_amount }}</span
                              >
                            </div>
                            <div class="ts-flex ts-items-center">
                              <div class="input-group qty">
                                <div class="input-group-append">
                                  <a
                                    href="#"
                                    class="btn btn-default"
                                    @click.prevent="
                                      setPromotionItemFreeItem(
                                        order.product_id,
                                        order.uom_id,
                                        order.unit_price,
                                        order.quantity-- - 1
                                      )
                                    "
                                    :disabled="order.quantity <= 1"
                                    ><i class="fa fa-minus"></i
                                  ></a>
                                </div>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model.number="order.quantity"
                                  @input="
                                    setPromotionItemFreeItem(
                                      order.product_id,
                                      order.uom_id,
                                      order.unit_price,
                                      order.quantity
                                    )
                                  "
                                  :class="{
                                    'is-invalid': errors.has(
                                      'products.' + index + '.quantity'
                                    )
                                  }"
                                />
                                <div class="input-group-prepend">
                                  <a
                                    href="#"
                                    class="btn btn-default"
                                    @click.prevent="
                                      setPromotionItemFreeItem(
                                        order.product_id,
                                        order.uom_id,
                                        order.unit_price,
                                        order.quantity++ + 1
                                      )
                                    "
                                    ><i class="fa fa-plus"></i
                                  ></a>
                                </div>
                              </div>
                              <div>
                                <input
                                  v-model="order.discount_rate"
                                  type="number"
                                  placeholder="discount"
                                  class="ts-w-12 ts-font-semibold ts-mt-2 ts-ml-3 ts-px-1 ts-py-1 ts-rounded-sm ts-border ts-outline-none ts-border-gray-400 ts-text-center"
                                />
                                <span class="ts-font-semibold ts-ml-1">%</span>
                              </div>
                            </div>
                            <div
                              class="validate"
                              v-if="
                                errors.has('products.' + index + '.quantity')
                              "
                            >
                              {{
                                errors.first('products.' + index + '.quantity')
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 total-price text-success">
                        {{ defaultCrrency }} {{ order.grand_total }}
                        <br />
                        <br />
                        <a
                        href="#"
                        class="btn btn-danger btn-xs"
                        v-if="
                          order.cooking_status_id != 2 ||
                            order.cooking_status_id != 3
                        "
                        @click.prevent="
                          () => [
                            (product_id_delete = order.product_id),
                            (uom_id_delete = order.uom_id)
                          ]
                        "
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                        <br />
                        <small class="ts-text-gray-600"
                          >In stock:
                          <b class="text-green">
                            {{ order.available_quantity }}</b
                          ></small
                        >
                      </div>
                      <div
                        class="pos-remove-confirmation"
                        v-if="
                          product_id_delete == order.product_id &&
                            uom_id_delete == order.uom_id
                        "
                      >
                        <svg
                          width="2em"
                          height="2em"
                          viewBox="0 0 16 16"
                          class="mr-2"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                          />
                          <path
                            fill-rule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                          />
                        </svg>
                        {{ $t('are_you_sure_to_delete') }}
                        <a
                          href="#"
                          class="btn btn-white ml-auto mr-2"
                          @click.prevent="
                            () => [
                              (product_id_delete = null),
                              (uom_id_delete = null)
                            ]
                          "
                          >{{ $t('no') }}</a
                        >
                        <a
                          href="#"
                          class="btn btn-danger"
                          @click.prevent="removeItem(order)"
                          >{{ $t('yes') }}</a
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="dataSend.products.length <= 0 && activeTabKey == 0"
                    class="h-100 d-flex align-items-center justify-content-center text-center p-20"
                  >
                    <div>
                      <div class="mb-3 mt-n5 ts-text-gray-400">
                        <i class="fas fa-shopping-cart fa-5x"></i>
                      </div>
                      <h4>{{ $t('martSale.noProductOrderFound') }}</h4>
                    </div>
                  </div>
                </ts-loading-banner>
              </ts-tab-pane>
              <ts-tab-pane :tabKey="1">
                <div
                  v-if="activeTabKey == 1"
                  class="ts-shadow-md ts-sticky ts-top-0 ts-bottom-0 ts-bg-white ts-z-50"
                >
                  <search-order-history v-model="orderHistoryOptions" />
                </div>
                <div
                  class="pos-table"
                  v-if="orderHistories.length > 0 && activeTabKey == 1"
                >
                  <div
                    class="pos-table-row"
                    v-for="(order, index) in orderHistories"
                    :key="index"
                    @click="onOrderSelected(order)"
                    :class="[
                      orderStatus(order),
                      { selected: selected_order == order.order_no }
                    ]"
                  >
                    <div class="row">
                      <div class="col-8">
                        <div class="pos-product-thumb">
                          <div class="info">
                            <div class="title">
                              {{
                                order.customer
                                  ? order.customer.customer_name +
                                    '|' +
                                    order.customer.gender
                                  : ''
                              }}
                            </div>
                            <div class="title">
                              <i class="fas fa-phone-volume"></i>
                              {{
                                order.customer
                                  ? order.customer.contact_number
                                  : ''
                              }}
                            </div>
                            <div class="desc">
                              {{ $t('martSale.order') }}:
                              <b class="ts-text-blue-600"
                                >#{{ order.order_no }}</b
                              ><br />
                              <i class="far fa-clock"></i>
                              {{ timeFormat(order.stock_out_date) }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-4 ts-text-right">
                        <div class="ts-font-bold text-success">
                          {{ defaultCrrency }} {{ order.grand_total }}
                        </div>
                        <br />
                        <div class="desc">
                          <span class="badge badge-success" v-if="order.is_paid"
                            >$ {{ $t('martSale.paie') }}</span
                          >
                          <span class="badge badge-danger" v-else
                            >$ {{ $t('martSale.unpaid') }}</span
                          ><br />
                          <span class="ts-mt-1"
                            >{{ order.stock_out_detail.length }}
                            {{ $t('martSale.orders') }}</span
                          >
                        </div>
                      </div>
                      <!-- <div class="pos-remove-confirmation">
                      <svg
                        width="2em"
                        height="2em"
                        viewBox="0 0 16 16"
                        class="mr-2"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                        />
                        <path
                          fill-rule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                        />
                      </svg>
                      Remove this item?
                      <a href="javascript:;" class="btn btn-white ml-auto mr-2"
                        >No</a
                      >
                      <a href="javascript:;" class="btn btn-danger">Yes</a>
                    </div> -->
                    </div>
                  </div>
                </div>
                <div
                  v-if="orderHistories.length <= 0 && activeTabKey == 1"
                  class="h-100 d-flex align-items-center justify-content-center text-center p-20"
                >
                  <div>
                    <div class="mb-3 mt-n5 ts-text-gray-400">
                      <i class="fas fa-shopping-bag fa-5x"></i>
                    </div>
                    <h4>{{ $t('martSale.noOrderHistoryFound') }}</h4>
                  </div>
                </div>
              </ts-tab-pane>
            </ts-tab-panes>
            <div class="pos-sidebar-footer ts-whitespace-no-wrap">
              <div class="subtotal">
                <div class="text">{{ $t('martSale.subtotal') }}</div>
                <div class="price">
                  {{ defaultCrrency }} {{ dataSend.sub_total }}
                </div>
              </div>
              <div class="taxes">
                <div class="text">
                  {{ $t('martSale.vat') }}
                  {{ vatRate ? '(' + vatRate + '%)' : '' }}
                </div>
                <div class="price">
                  {{ defaultCrrency }} {{ dataSend.vat_amount }}
                </div>
              </div>
              <hr class="opacity-1" />
              <div class="total">
                <div class="text">{{ $t('martSale.grandTotal') }}</div>
                <div class="price">
                  {{ defaultCrrency }} {{ dataSend.grand_total }}
                </div>
              </div>
              <div class="btn-row ts-space-x-2">
                <ts-button
                  @click.prevent="() => (showForm = true)"
                  :waiting="waiting"
                  ><i class="fa fa-user-clock fa-fw fa-lg"></i>
                  {{ $t('martSale.shiftClose') }}</ts-button
                >
                <ts-button
                  @click.prevent="printBill"
                  v-if="hasNewItem && selected_order"
                  :waiting="printing"
                  ><i
                    v-if="!printing"
                    class="fa fa-file-invoice fa-fw fa-lg"
                  ></i>
                  {{ $t('martSale.printBill') }}</ts-button
                >
                <ts-button
                  color="primary"
                  @click.prevent="submitOrder"
                  :waiting="submiting"
                  v-if="!hasNewItem"
                  ><i v-if="!submiting" class="fa fa-check fa-fw fa-lg"></i>
                  {{ $t('martSale.submitOrder') }}</ts-button
                >
                <ts-button
                  color="success"
                  @click.prevent="showBillForm"
                  :disabled="dataSend.products.length <= 0"
                  ><i class="fa fa-file-invoice-dollar fa-fw fa-lg"></i>
                  {{ $t('martSale.checkBill') }}</ts-button
                >
              </div>
            </div>
          </div>
          <!-- END pos-sidebar -->
        </div>
        <!-- END pos -->

        <!-- BEGIN pos-mobile-sidebar-toggler -->
        <a
          href="#"
          class="pos-mobile-sidebar-toggler"
          v-on:click="posMobileSidebarToggled"
        >
          <svg
            viewBox="0 0 16 16"
            class="img"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M14 5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5zM1 4v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4H1z"
            />
            <path
              d="M8 1.5A2.5 2.5 0 0 0 5.5 4h-1a3.5 3.5 0 1 1 7 0h-1A2.5 2.5 0 0 0 8 1.5z"
            />
          </svg>
          <span class="badge">{{ dataSend.products.length }}</span>
        </a>
        <!-- END pos-mobile-sidebar-toggler -->

        <!-- BEGIN #modalPosItem -->
        <b-modal
          modal-class="modal-pos-item"
          :hide-header="true"
          :hide-footer="true"
          size="lg"
          body-class="p-0"
          id="modalPosItem"
          centered
        >
          <a href="#" class="close" @click="close"
            ><i class="fa fa-times"></i
          ></a>
          <div class="pos-product" v-for="(p, index) in selectedProduct">
            <div class="pos-product-img">
              <img
                class="img"
                v-lazy="{
                  src: p.photo
                    ? p.photo
                    : require('@/assets/default-product.jpg'),
                  error: require('@/assets/default-product.jpg'),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
              />
            </div>
            <div class="pos-product-info">
              <div class="title ts-whitespace-no-wrap">
                {{ p.product_name_kh ? p.product_name_kh : p.product_name_en }}
              </div>
              <div class="desc">
                {{ p.product_name_en }}<br />
                <span class="text-info">{{ p.barcode }}</span> In stock: <span class="text-info">{{ p.current_stock }}</span>
              </div>
              <div class="desc ts-whitespace-no-wrap text-warning">
                {{ p.storage_name_en ? 'Storage: ' + p.storage_name_en : '' }}
              </div>
              <div class="price ts-text-blue-600">
                {{ defaultCrrency }} {{ defaultPrice(p.product_id) }}
              </div>
              <b-alert
                v-if="
                  getPromotionBuyItemFreeItem(
                    p.product_id,
                    saleCodeByDefaultUom(p.product_id)
                      ? saleCodeByDefaultUom(p.product_id).unit_of_measure
                          .uom_id
                      : 0
                  )
                "
                variant="success"
                show
              >
                {{ $t('martSale.buy') }}
                <strong>
                  {{
                    getPromotionBuyItemFreeItem(
                      p.product_id,
                      saleCodeByDefaultUom(p.product_id)
                        ? saleCodeByDefaultUom(p.product_id).unit_of_measure
                            .uom_id
                        : 0
                    ).free_item.buy_quantity
                  }}
                </strong>
                {{ $t('martSale.getPromotion') }}
                {{
                  getPromotionBuyItemFreeItem(
                    p.product_id,
                    saleCodeByDefaultUom(p.product_id)
                      ? saleCodeByDefaultUom(p.product_id).unit_of_measure
                          .uom_id
                      : 0
                  ).free_item.condition_type
                }}
                {{ $t('martSale.item') }}.
                <br />
                <table width="100%" class="ts-text-blue-600">
                  <tr>
                    <th>{{ $t('martSale.itemName') }}</th>
                    <th class="text-center">{{ $t('martSale.qty') }}</th>
                    <th class="text-right">{{ $t('martSale.price') }}</th>
                  </tr>
                  <tr
                    v-for="(item, index) in getPromotionBuyItemFreeItem(
                      p.product_id,
                      saleCodeByDefaultUom(p.product_id)
                        ? saleCodeByDefaultUom(p.product_id).unit_of_measure
                            .uom_id
                        : 0
                    ).free_item.free_item_list"
                    :key="index"
                  >
                    <td>{{ item.product_name_free_en }}</td>
                    <td class="text-center">{{ item.free_quantity }}</td>
                    <td class="text-right">{{ item.price }}</td>
                  </tr>
                </table>
              </b-alert>
              <hr />
              <div class="option-row">
                <div class="qty">
                  <div class="input-group">
                    <a
                      href="#"
                      class="btn btn-default"
                      @click.prevent="decrement"
                      :disabled="quantity <= 1"
                      ><i class="fa fa-minus"></i
                    ></a>
                    <input
                      type="text"
                      class="form-control border-0 text-center"
                      v-model.number="quantity"
                      style="padding: 0"
                    />
                    <a
                      href="#"
                      class="btn btn-default"
                      @click.prevent="increment"
                      ><i class="fa fa-plus"></i
                    ></a>
                  </div>
                </div>
              </div>
              <div class="option-row" style="width: 94px">
                <input
                  type="number"
                  class="form-control text-center"
                  v-model.number="discount_rate"
                  placeholder="Dis %"
                />
              </div>
              <div class="option-row">
                <div class="option-title">{{ $t('martSale.size') }}</div>
                <div class="option-list" v-if="p.sale_code.length > 0">
                  <div class="option" v-for="(s, index) in p.sale_code">
                    <input
                      type="radio"
                      :id="'size' + s.pro_sale_code_id"
                      v-model="size"
                      :value="s.unit_of_measure.uom_id"
                      class="option-input"
                      checked
                      @input="chooseSize(s)"
                    />
                    <label
                      class="option-label"
                      :for="'size' + s.pro_sale_code_id"
                    >
                      <span class="option-text">{{
                        s.unit_of_measure.uom_name_en
                      }}</span>
                      <span class="option-price"
                        >{{ defaultCrrency }}
                        {{
                          s.product_price ? s.product_price.sale_price : ''
                        }}</span
                      >
                    </label>
                  </div>
                </div>
              </div>
              <div class="option-row" v-if="p.product_add_on.length > 0">
                <div class="option-title">{{ $t('martSale.addOn') }}</div>
                <div class="option-list">
                  <div
                    class="option"
                    v-for="(add_on, index) in p.product_add_on"
                  >
                    <input
                      type="checkbox"
                      v-model="addon"
                      :value="add_on"
                      class="option-input"
                      :id="'addon' + add_on.addon_pro_sale_code_id"
                      @input="chooseAddOn(add_on ? add_on.sale_code : '')"
                    />
                    <label
                      class="option-label"
                      :for="'addon' + add_on.addon_pro_sale_code_id"
                    >
                      <span class="option-text">{{
                        add_on.sale_code
                          ? add_on.sale_code.product.product_name_en
                          : ''
                      }}</span>
                      <span class="option-price"
                        >+ {{ defaultCrrency }}
                        {{
                          add_on.sale_code
                            ? add_on.sale_code.product_price
                              ? add_on.sale_code.product_price.sale_price
                              : 0
                            : ''
                        }}</span
                      >
                    </label>
                  </div>
                </div>
              </div>
              <div class="option-row">
                <textarea
                  rows="2"
                  class="form-control"
                  v-model="remarks"
                  :placeholder="$t('remarks')"
                ></textarea>
              </div>
              <div class="btn-row">
                <a
                  href="#"
                  class="btn btn-default"
                  data-dismiss="modal"
                  @click.prevent="close"
                  >{{ $t('cancel') }}</a
                >
                <ts-button
                  :waiting="addingToCart"
                  color="success"
                  @click.prevent="addToCart"
                >
                  {{ $t('martSale.addToCart') }}
                  <i class="fa fa-plus fa-fw ml-2"></i
                ></ts-button>
              </div>
            </div>
          </div>
        </b-modal>
        <!-- END #modalPosItem -->
        <!-- BEGIN #modalPosItem -->
        <a-modal
          v-model="visible"
          :title="
            promotion_free_item_per_amount
              ? promotion_free_item_per_amount.promotion_name
              : ''
          "
          on-ok="handleOk"
        >
          <template slot="footer">
            <a-button key="back" @click="handleCancel">
              {{ $t('cancel') }}
            </a-button>
            <a-button
              key="submit"
              type="primary"
              :loading="waiting"
              @click="handleOk"
            >
              {{ $t('martSale.addFreeItem') }}
            </a-button>
          </template>
          <table
            id="list"
            class="table table-hover ui-table ts-table"
            v-if="conditions"
          >
            <thead>
              <tr>
                <th class="text-center">
                  <ts-checkbox
                    v-if="conditions.free_status == 'All'"
                    @change="selectAll"
                    v-model="checked_all"
                  ></ts-checkbox>
                </th>
                <th class="ts-whitespace-no-wrap">
                  {{ $t('martSale.productName') }}
                </th>
                <th class="ts-whitespace-no-wrap text-center">
                  {{ $t('martSale.uom') }}
                </th>
                <th class="ts-whitespace-no-wrap text-center">
                  {{ $t('martSale.quantity') }}
                </th>
              </tr>
            </thead>
            <tbody v-if="conditions">
              <tr
                v-for="(record, index) in conditions.discount_items"
                :key="index"
              >
                <td class="text-center">
                  <ts-checkbox
                    v-if="conditions.free_status == 'All'"
                    :value="{
                      product_id: record.product_id,
                      uom_id: record.uom_id,
                      quantity: record.quantity
                    }"
                    v-model="selectedProductFree"
                    @change="
                      selectedProductFree.length ==
                      conditions.discount_items.length
                        ? (checked_all = true)
                        : (checked_all = false)
                    "
                  ></ts-checkbox>
                  <input
                    v-if="conditions.free_status == 'Any'"
                    type="radio"
                    v-model="selectedProductFree"
                    :value="[
                      {
                        product_id: record.product_id,
                        uom_id: record.uom_id,
                        quantity: record.quantity
                      }
                    ]"
                    :checked="
                      selectedProductFree[0].product_id == record.product_id &&
                      selectedProductFree[0].uom_id == record.uom_id &&
                      selectedProductFree[0].quantity == record.quantity
                        ? true
                        : false
                    "
                  />
                </td>
                <td class="ts-whitespace-no-wrap">
                  {{ record.product_name_en }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.uom_name_en }}
                </td>
                <td class="ts-whitespace-no-wrap text-center">
                  {{ record.quantity }}
                </td>
              </tr>
            </tbody>
          </table>
        </a-modal>
        <a-modal
          v-if="showForm"
          v-model="showForm"
          :title="$t('martSale.shiftClose')"
          centered
          @cancel="closeForm"
          :zIndex="1020"
          :footer="null"
          width="400px"
        >
          <shift-close @cancel="closeForm" @preview="receiptPreview" />
        </a-modal>
        <a-modal
          v-if="showPreviewReciept"
          v-model="showPreviewReciept"
          :title="$t('martSale.previewReciept')"
          centered
          @cancel="closeForm"
          :zIndex="1020"
          :footer="null"
          width="400px"
        >
          <shift-close @cancel="closeForm" @preview="receiptPreview" />
        </a-modal>
        <b-modal
          modal-class="modal-pos-item"
          :hide-header="true"
          :hide-footer="true"
          size="lg"
          body-class="p-0"
          id="modalCheckBill"
          centered
          :no-close-on-backdrop="true"
        >
          <check-bill
            @close="() => $bvModal.hide('modalCheckBill')"
            @success="billSuccess"
            :data="dataSend"
          />
        </b-modal>
        <!-- add customer -->
        <a-drawer
          v-if="add_new_customer"
          :title="$t('wholesale.createNewCustomer')"
          :width="400"
          :zIndex="1020"
          :visible="add_new_customer"
          :body-style="{ paddingBottom: '80px' }"
          :maskClosable="false"
          @close="() => (add_new_customer = false)"
        >
          <AddNewCustomer @cancel="onCancel" @data="setCustomer" />
        </a-drawer>
      </div>
    </div>
  </div>
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import CheckBill from './components/check-bill'
import SearchBox from './components/search-box'
import ShiftClose from './components/shift-close'
import Counter from './components/counter'
import { Errors } from 'form-backend-validation'
import TsSelectCustomer from '@/components/common/TsSelectCustomer'
import AddNewCustomer from './components/add-new-customer.vue'
import SearchOrderHistory from './components/search-order-history.vue'
import { debounce } from 'lodash'

export default {
  name: 'martSale',
  components: {
    SearchBox,
    ShiftClose,
    TsSelectCustomer,
    CheckBill,
    AddNewCustomer,
    SearchOrderHistory
  },
  data() {
    return {
      add_new_customer: false,
      activeTabKey: 0,
      showFormBill: false,
      activeKey: '',
      activeKeyCategory: '',
      mode: 'top',
      errors: new Errors(),
      posMobileSidebar: false,
      loading: false,
      waiting: false,
      visible: false,
      submiting: false,
      printing: false,
      checked_all: false,
      productFetching: false,
      showChooseFreeItems: true,
      selectedProductId: null,
      quantity: 1,
      size: null,
      selectedProductFree: [],
      addon: [],
      products: [],
      subCategories: [],
      categories: [],
      remarks: null,
      discount_rate: null,
      promo_type_id: null,
      currentTime: '',
      currentDate: '',
      promotion_free_item_per_amount: {},
      conditions: {},
      category_id: null,
      pro_group_id: null,
      fetchOptions: {
        search_value: ''
      },
      orderHistoryOptions: {
        search_value: ''
      },
      showForm: false,
      showPreviewReciept: false,
      addingToCart: false,
      counter: {
        counter_id: undefined
      },
      item: {
        product_id: null,
        uom_id: null,
        quantity: null,
        available_quantity: null,
        unit_price: null,
        discount_type: null,
        discount_rate: null,
        discount_amount: null,
        total_after_discount: null,
        vat_rate: null,
        vat_amount: null,
        grand_total: null,
        remarks: null,
        promo_free_item_cond_id: null,
        promo_type_id: null
      },
      itemAddon: [],
      dataSend: {
        stock_out_id: null,
        counter_id: null,
        order_no: null,
        customer_id: null,
        sub_total: null,
        discount: null,
        total_after_discount: null,
        vat_amount: null,
        vat_rate: null,
        grand_total: null,
        fx_rate: null,
        remark: null,
        paid_in_riel: null,
        paid_in_usd: null,
        change_in_riel: null,
        change_in_usd: null,
        paid_in_coupon: null,
        paid_in_credit_card: null,
        products: []
      },
      selected_order: '',
      orderSelected: {},
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ],
      product_id_delete: null,
      uom_id_delete: null
    }
  },
  filters: {
    format_number(value) {
      return `${value.toLocaleString()}`
    }
  },
  computed: {
    ...mapGetters('martSale/order', [
      'defaultPrice',
      'saleCodeByDefaultUom',
      'getUomName',
      'getProduct',
      'getPromotionDiscount',
      'getPromotionItemFreeItem',
      'getPromotionBuyItemFreeItem',
      'getPromotionFreeItemPerAmount'
    ]),
    ...mapState('martSale/order', ['companyInfo', 'order_histories']),
    productCategory() {
      return this.$store.state.martSale.order.productCategories
    },
    companyLogo() {
      return this.companyInfo.length > null
        ? this.companyInfo[0].company_logo
        : ''
    },
    selectedProduct() {
      return this.$store.state.martSale.order.products.filter(
        s => s.product_id == this.selectedProductId
      )
    },
    vatRate() {
      return parseFloat(
        this.$store.state.martSale.order.systemSettings.vat_rate
      )
    },
    exchangeRate() {
      return parseFloat(this.$store.state.martSale.order.systemSettings.fx_rate)
    },
    defaultCrrency() {
      return this.$store.state.martSale.order.systemSettings.default_currency
    },
    toCurrency() {
      return this.$store.state.martSale.order.systemSettings.to_currency
    },
    orderHistories() {
      if (_.isEmpty(this.order_histories)) return []

      if (this.orderHistoryOptions.search_value) {
        return _.orderBy(this.order_histories, ['order_no'], ['asc']).filter(
          option => {
            if (
              option.customer.contact_number === null ||
              option.customer.contact_number === undefined ||
              option.customer.customer_name === null ||
              option.customer.customer_name === undefined ||
              option.order_no === null ||
              option.order_no === undefined
            )
              return false

            return (
              option.customer.contact_number
                .toLowerCase()
                .startsWith(
                  this.orderHistoryOptions.search_value.toLowerCase()
                ) ||
              option.customer.customer_name
                .toLowerCase()
                .startsWith(
                  this.orderHistoryOptions.search_value.toLowerCase()
                ) ||
              option.order_no
                .toLowerCase()
                .startsWith(this.orderHistoryOptions.search_value.toLowerCase())
            )
          }
        )
      }
      return _.orderBy(this.order_histories, ['order_no'], 'ASC')
    },
    hasNewItem() {
      if (!_.isEmpty(this.orderSelected)) {
        if (
          this.dataSend.products.length > 0 &&
          this.orderSelected.stock_out_detail.length > 0
        ) {
          if (
            !this.compareObject(
              this.orderSelected.stock_out_detail,
              this.dataSend.products
            ) ||
            this.dataSend.products.filter(
              i => i.stock_out_id == undefined || i.stock_out_id == null
            ).length > 0
          ) {
            return false
          }
        }
      }

      if (this.dataSend.products.length > 0) {
        if (
          this.dataSend.products.filter(
            i => i.stock_out_id == undefined || i.stock_out_id == null
          ).length > 0
        ) {
          return false
        }
      }

      return true
    },
    locale() {
      return this.$root.$i18n.locale;
    },
    flag() {
      if (this.$root.$i18n.locale === 'kh') return 'kh'
      else if (this.$root.$i18n.locale === 'en') return 'us'
    }
  },
  async created() {
    // this.choseCounter()
    PageOptions.pageEmpty = true
    await this.fetchProducts()
    await this.fetchBefore()
    this.checkReload()
    await this.fetchOrderHistory().catch(error => {
      this.$notification['error']({
        message: 'ORDER HISTORY',
        description: error.message,
        placement: 'bottomRight'
      })
    })
    setInterval(() => this.updateCurrentTime(), 1 * 1000)
    this.dataSend.counter_id = parseInt(localStorage.getItem('counterId'))
  },
  methods: {
    ...mapActions('martSale/order', [
      'fetchBefore',
      'availableQuantity',
      'fetchOrderHistory'
    ]),
    checkReload() {
      window.onbeforeunload = function() {
        return 'Are you sure you want to close the window?'
      }
    },
    setCustomer(data) {
      this.$store.commit('martSale/order/PUSH_NEW_CUSTOMER', data)
      this.dataSend.customer_id = data.customer_id
    },
    onCancel() {
      this.add_new_customer = false
    },
    printBill() {
      this.printing = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'martSale/order/store',
          Object.assign({}, this.dataSend, {
            counter_id: parseInt(localStorage.getItem('counterId')),
            action_type: 'print-bill'
          })
        )
        .then(response => {
          this.$notification['success']({
            message: 'PRINT BILL',
            description: response.message,
            placement: 'topRight'
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          if (this.errors.first('change_in_usd')) {
            this.$notification['error']({
              message: 'PRINT BILL',
              description: this.errors.first('change_in_usd'),
              placement: 'bottomRight'
            })
          } else {
            this.$notification['error']({
              message: 'PRINT BILL',
              description: error.message,
              placement: 'bottomRight'
            })
          }
        })
        .finally(() => {
          this.printing = false
        })
    },
    submitOrder() {
      this.submiting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'martSale/order/store',
          Object.assign({}, this.dataSend, {
            counter_id: parseInt(localStorage.getItem('counterId')),
            action_type: 'submit-order'
          })
        )
        .then(response => {
          this.fetchOrderHistory()
          this.clearInput()
          this.$notification['success']({
            message: 'SUBMIT ORDER',
            description: response.message,
            placement: 'topRight'
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          if (this.errors.first('change_in_usd')) {
            this.$notification['error']({
              message: 'SUBMIT ORDER',
              description: this.errors.first('change_in_usd'),
              placement: 'bottomRight'
            })
          } else {
            this.$notification['error']({
              message: 'SUBMIT ORDER',
              description: error.message,
              placement: 'bottomRight'
            })
          }
        })
        .finally(() => {
          this.submiting = false
        })
    },
    timeFormat(dateTime) {
      return moment(dateTime).format('LTS')
    },
    onOrderSelected(order) {
      if (order.order_no != this.selected_order) {
        this.posMobileSidebar = !this.posMobileSidebar
        this.$store.commit('martSale/order/SET_SELECTED_ORDER_HISTORIES', order)
        this.orderSelected = order
        this.selected_order = order.order_no
        this.setData()
        this.changeTab(0)
      } else {
        this.posMobileSidebar = !this.posMobileSidebar
        this.$store.commit('martSale/order/SET_SELECTED_ORDER_HISTORIES', {})
        this.orderSelected = {}
        this.selected_order = ''
        this.clearInput()
      }
    },
    orderStatus(order) {
      if (order.order_no == this.selected_order) {
        return ''
      }
      return 'in-use'
    },
    setData() {
      if (!_.isEmpty(this.orderSelected)) {
        this.dataSend = {
          counter_id: parseInt(localStorage.getItem('counterId')),
          stock_out_id: this.orderSelected.stock_out_id,
          order_no: this.orderSelected.order_no,
          customer_id: this.orderSelected.customer_id,
          sub_total: this.orderSelected.sub_total,
          discount: this.orderSelected.discount,
          discount_rate: this.orderSelected.discount_rate,
          discount_type: this.orderSelected.discount_type,
          total_after_discount: this.orderSelected.total_after_discount,
          vat_amount: this.orderSelected.vat_amount,
          vat_rate: this.orderSelected.vat_rate,
          grand_total: this.orderSelected.grand_total,
          fx_rate: this.orderSelected.fx_rate,
          remark: this.orderSelected.remark,
          paid_in_riel: this.orderSelected.paid_in_riel,
          paid_in_usd: this.orderSelected.paid_in_usd,
          change_in_riel: this.orderSelected.change_in_riel,
          change_in_usd: this.orderSelected.change_in_usd,
          paid_in_coupon: this.orderSelected.paid_in_coupon,
          paid_in_credit_card: this.orderSelected.paid_in_credit_card,
          products: []
        }
        this.orderSelected.stock_out_detail.map(detail => {
          var product = this.$store.state.martSale.order.products.find(
            p => p.product_id == detail.product_id
          )
          this.dataSend.products.unshift({
            stock_out_id: detail.stock_out_id,
            product_id: detail.product_id,
            quantity: detail.quantity,
            available_quantity: product.current_stock,
            unit_price: detail.unit_price,
            uom_id: detail.uom_id,
            discount_amount: detail.discount_amount,
            discount_rate: detail.discount_rate,
            discount_type: detail.discount_type,
            grand_total: detail.grand_total,
            ref_promo_product_id: detail.ref_promo_product_id,
            promo_type_id: detail.promo_type_id,
            remarks: detail.remarks,
            total_after_discount: detail.total_after_discount,
            vat_amount: detail.vat_amount,
            vat_rate: detail.vat_rate
          })
        })
      }
    },
    billSuccess() {
      this.$bvModal.hide('modalCheckBill')
      this.clearInput()
      this.fetchOrderHistory()
    },
    fetchProducts(attributes) {
      this.productFetching = true
      this.$store
        .dispatch('martSale/order/fetchProducts', attributes)
        .then(() => this.onChangeCategory(null))
        .finally(() => (this.productFetching = false))
    },
    posMobileSidebarToggled: function() {
      this.posMobileSidebar = !this.posMobileSidebar
    },
    onChangeCategory(category_id) {
      this.category_id = category_id
      this.categories = []
      this.subCategories = []
      this.activeKey = ''
      this.activeKeyCategory = ''
      if (category_id) {
        // get product specify  category
        this.subCategories = this.productCategory.filter(
          c => c.category_id == category_id
        )[0].sub_categories
        this.products = this.$store.state.martSale.order.products
          .filter(
            p =>
              // _.includes([1, 2], p.product_type_id) &&
              p.category_id == category_id
          )
          .filter(
            p =>
              p.barcode
                .toLowerCase()
                .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
              p.product_name_en
                .toLowerCase()
                .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
              (p.product_name_kh
                ? p.product_name_kh
                    .toLowerCase()
                    .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1
                : null)
          )
          .splice(0, 40)
        return
      }
      this.products = this.$store.state.martSale.order.products
        .filter(p =>
          // _.includes([1, 2], p.product_type_id) &&
          _.includes(
            p.sale_code.map(s => s.is_top_sale),
            true
          )
        )
        .filter(
          p =>
            p.barcode
              .toLowerCase()
              .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
            p.product_name_en
              .toLowerCase()
              .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
            (p.product_name_kh
              ? p.product_name_kh
                  .toLowerCase()
                  .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1
              : null)
        )
        .splice(0, 40)
      this.categories = this.productCategory.filter(c =>
        _.includes(_.uniq(this.products.map(p => p.category_id)), c.category_id)
      )
      this.subCategories = []
      return
    },
    changeTab(index) {
      this.activeTabKey = index
    },
    onChangeSubCategory(pro_group_id) {
      if (pro_group_id) {
        // get product specify sub category
        this.products = this.$store.state.martSale.order.products
          .filter(
            p =>
              // _.includes([1, 2], p.product_type_id) &&
              p.product_group.pro_group_id == pro_group_id
          )
          .filter(
            p =>
              p.barcode
                .toLowerCase()
                .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
              p.product_name_en
                .toLowerCase()
                .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
              (p.product_name_kh
                ? p.product_name_kh
                    .toLowerCase()
                    .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1
                : null)
          )
          .splice(0, 40)
        return
      }
    },
    onChangeMainCategory(category_id) {
      if (category_id) {
        // get product specify main category
        this.products = this.$store.state.martSale.order.products
          .filter(
            p =>
              p.category_id == category_id &&
              // _.includes([1, 2], p.product_type_id) &&
              _.includes(
                p.sale_code.map(s => s.is_top_sale),
                true
              )
          )
          .filter(
            p =>
              p.barcode
                .toLowerCase()
                .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
              p.product_name_en
                .toLowerCase()
                .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
              (p.product_name_kh
                ? p.product_name_kh
                    .toLowerCase()
                    .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1
                : null)
          )
          .splice(0, 40)
        return
      }
    },
    selectProduct(product_id) {
      this.clearOldSelectPro()
      this.selectedProductId = product_id
      let saleCode = this.saleCodeByDefaultUom(product_id)
      this.size = saleCode.unit_of_measure.uom_id
      this.chooseSize(saleCode)
      this.setPromotionDiscount(product_id)
    },
    addProduct(product_id) {
      this.clearOldSelectPro()
      this.selectedProductId = product_id
      let saleCode = this.saleCodeByDefaultUom(product_id)
      this.size = saleCode.unit_of_measure.uom_id
      this.chooseSize(saleCode)
      this.setPromotionDiscount(product_id)
      this.addToCart()
    },
    setPromotionDiscount(product_id) {
      let promotion_discount = this.getPromotionDiscount(product_id)
      this.remarks = promotion_discount
        ? promotion_discount.promotion_name
        : null
      this.discount_rate = promotion_discount
        ? promotion_discount.promo_discount_value
        : null
      this.promo_type_id = promotion_discount
        ? promotion_discount.promo_type_id
        : null
    },
    clearOldSelectPro() {
      this.quantity = 1
      this.size = null
      this.addon = []
      this.remarks = null
      this.discount_rate = null
      this.promo_type_id = null
      this.itemAddon = []
    },
    increment() {
      this.quantity++
    },
    decrement() {
      this.quantity--
    },
    chooseSize(saleCode) {
      this.addItem(saleCode)
    },
    chooseAddOn(saleCode) {
      this.addItem(saleCode, true)
    },
    searchBarcode() {
      var product = this.$store.state.martSale.order.products
        .filter(
          p =>
            p.barcode.toLowerCase() == this.fetchOptions.search_value.toLowerCase() ||
            p.product_name_en.toLowerCase() == this.fetchOptions.search_value.toLowerCase() ||
            (p.product_name_kh ? p.product_name_kh.toLowerCase() : '') == this.fetchOptions.search_value.toLowerCase()
        )
        .reduce((init, value) => (init = value), null)
      if (product) {
        this.selectProduct(product.product_id)
        this.addToCart()
        this.fetchOptions.search_value = ''
      } else {
        this.$notification['info']({
          message: 'Search Barcode',
          description: 'Not found product!',
          placement: 'buttomRight'
        })
        this.fetchOptions.search_value = ''
      }
    },
    async addToCart() {
      var product = this.$store.state.martSale.order.products.find(
        p => p.product_id == this.item.product_id
      )
      this.item.available_quantity = product.current_stock
      this.addingToCart = true
      var dis = this.dataSend.products
        .filter(p => p.product_id == this.item.product_id)
        .reduce((init, value) => (init = value.discount_rate), 0)
      this.item.quantity = this.quantity
      this.item.discount_rate = this.discount_rate ? this.discount_rate : dis
      this.item.promo_type_id = this.promo_type_id
      this.item.remarks = this.remarks
      this.item.promo_free_item_cond_id = null
      this.$forceUpdate()
      let var_product = this.dataSend.products
        .filter(
          p =>
            p.product_id == this.item.product_id &&
            p.uom_id == this.item.uom_id &&
            p.unit_price > 0
        )
        .reduce((init, value) => (init = value), {})
      if (!_.isEmpty(var_product)) {
        var_product.quantity += this.item.quantity
        var_product.discount_rate = this.discount_rate
          ? this.discount_rate
          : dis
        var_product.remarks = this.remarks
        this.calculate()
        this.setPromotionItemFreeItem(
          this.item.product_id,
          this.item.uom_id,
          this.item.unit_price,
          var_product.quantity
        )
        //move to index 0
        this.arraymove(this.dataSend.products, this.dataSend.products.indexOf(var_product), 0)
      } else {
        this.dataSend.products.unshift(_.clone(this.item))
        this.dataSend.vat_rate = parseFloat(
          this.$store.state.martSale.order.systemSettings.vat_rate
        )
        this.setPromotionItemFreeItem(
          this.item.product_id,
          this.item.uom_id,
          this.item.unit_price,
          this.item.quantity
        )
      }
      this.itemAddon.forEach(el => {
        let duplicate = this.dataSend.products.filter(
          p => p.product_id == el.product_id && p.uom_id == el.uom_id
        )
        if (duplicate.length > 0) {
          duplicate[0].quantity += el.quantity
           //move to index 0
          this.arraymove(this.dataSend.products, this.dataSend.products.indexOf(duplicate[0]), 0)
        } else {
          this.dataSend.products.unshift(_.clone(el))
        }
      })
      this.close()
      this.addingToCart = false
    },
    setPromotionItemFreeItem(product_id, uom_id, unit_price, quantity) {
      if (unit_price > 0) {
        var free_item = this.getPromotionItemFreeItem(
          product_id,
          uom_id,
          quantity
        )
        if (free_item) {
          free_item.map(el => {
            if (el.quantity > 0) {
              let var_product = this.dataSend.products
                .filter(
                  p =>
                    p.product_id == el.product_id &&
                    p.uom_id == el.uom_id &&
                    p.promo_type_id == el.promotions.promo_type_id
                )
                .reduce((init, value) => (init = value), {})

              if (!_.isEmpty(var_product)) {
                var_product.quantity = el.quantity
                var product = this.$store.state.martSale.order.products.find(
                  p => p.product_id == el.product_id
                )
                var_product.available_quantity = product.current_stock
              } else {
                var product = this.$store.state.martSale.order.products.find(
                  p => p.product_id == el.product_id
                )
                this.item.available_quantity = product.current_stock
                this.item.product_id = el.product_id
                this.item.uom_id = el.uom_id
                this.item.quantity = el.quantity
                this.item.unit_price = el.unit_price
                this.item.discount_rate = 0
                this.item.remarks = el.promotions.promotion_name
                this.item.promo_type_id = el.promotions.promo_type_id
                this.dataSend.products.unshift(_.clone(this.item))
              }
            } else {
              let checkExists = this.dataSend.products
                .filter(
                  p =>
                    p.product_id == el.product_id &&
                    p.uom_id == el.uom_id &&
                    p.promo_type_id == el.promotions.promo_type_id
                )
                .reduce((init, value) => (init = value), {})

              if (!_.isEmpty(checkExists)) {
                this.dataSend.products.splice(
                  this.dataSend.products.indexOf(checkExists),
                  1
                )
              }
            }
          })
        }
      }
    },
    addItem(saleCode, add_on_type = false) {
      if (!add_on_type) {
        this.item.product_id = saleCode.product_id
        this.item.uom_id = saleCode.uom_id
        this.item.quantity = this.quantity
        this.item.unit_price = saleCode.product_price
          ? saleCode.product_price.sale_price
          : 0
        this.item.discount_type = '%'
        this.item.discount_rate = this.discount_rate
        this.item.remarks = this.remarks
        this.item.discount_amount = 0
        this.item.total_after_discount = 0
        this.item.vat_rate = 0
        this.item.vat_amount = 0
        this.item.grand_total = 0
      } else {
        let checkExists = this.itemAddon
          .filter(
            i =>
              i.product_id == saleCode.product_id && i.uom_id == saleCode.uom_id
          )
          .reduce((init, value) => (init = value), {})
        if (!_.isEmpty(checkExists)) {
          this.itemAddon.splice(this.itemAddon.indexOf(checkExists), 1)
          return
        }
        this.itemAddon.unshift({
          product_id: saleCode.product_id,
          uom_id: saleCode.uom_id,
          quantity: 1,
          unit_price: saleCode.product_price
            ? saleCode.product_price.sale_price
            : 0,
          discount_type: '%',
          discount_rate: 0,
          remarks: null,
          discount_amount: 0,
          total_after_discount: 0,
          vat_rate: 0,
          vat_amount: 0,
          grand_total: 0
        })
      }
    },
    calculate() {
      this.dataSend.products.forEach(el => {
        var amount = _.ceil(el.quantity * el.unit_price, 2)
        el.discount_amount = _.ceil(
          el.discount_type == '%'
            ? amount * (el.discount_rate / 100)
            : el.discount_rate,
          2
        )
        el.vat_amount = _.ceil(amount * (el.vat_rate / 100), 2)
        el.total_after_discount = _.ceil(amount - el.discount_amount, 2)
        el.grand_total = _.ceil(el.total_after_discount + el.vat_amount, 2)
      })

      this.dataSend.fx_rate = _.ceil(this.exchangeRate, 2)
      this.dataSend.sub_total = _.ceil(
        _.sumBy(this.dataSend.products, function(o) {
          return o.grand_total
        }),
        2
      )
      ;(this.dataSend.discount = 0), (this.dataSend.total_after_discount = 0)
      this.dataSend.vat_amount = _.round(
        this.dataSend.sub_total * (this.vatRate / 100),
        2
      )
      this.dataSend.grand_total = _.ceil(
        this.dataSend.sub_total + this.dataSend.vat_amount,
        2
      )
      this.dataSend.change_in_usd = _.ceil(
        this.dataSend.paid_in_usd +
          this.dataSend.paid_in_riel / this.dataSend.fx_rate -
          this.dataSend.grand_total,
        2
      )
      this.dataSend.change_in_riel = _.ceil(
        this.dataSend.change_in_usd * this.dataSend.fx_rate,
        2
      )
      this.removeFreeItemPerAmount()
    },
    removeItem(row) {
      this.dataSend.products.splice(this.dataSend.products.indexOf(row), 1)
      this.product_id_delete = null
      this.uom_id_delete = null
      // remove promotion item
      var free_item = this.getPromotionItemFreeItem(
        row.product_id,
        row.uom_id,
        row.quantity
      )
      if (free_item) {
        free_item.map(el => {
          if (free_item) {
            if (el.quantity > 0) {
              let checkExists = this.dataSend.products
                .filter(
                  p =>
                    p.product_id == el.product_id &&
                    p.uom_id == el.uom_id &&
                    p.promo_type_id == el.promotions.promo_type_id
                )
                .reduce((init, value) => (init = value), {})

              if (!_.isEmpty(checkExists)) {
                this.dataSend.products.splice(
                  this.dataSend.products.indexOf(checkExists),
                  1
                )
              }
            }
          }
        })
      }
    },
    close() {
      this.$bvModal.hide('modalPosItem')
    },
    updateCurrentTime() {
      this.currentDate = moment().format('dddd, MMM Do')
      this.currentTime = moment().format('LT')
    },
    selectAll(e) {
      if (e) {
        this.selectedProductFree = []
        this.conditions.discount_items.map(el => {
          this.selectedProductFree.unshift({
            product_id: el.product_id,
            uom_id: el.uom_id,
            quantity: el.quantity
          })
          this.checked_all = true
        })
      } else {
        this.selectedProductFree = []
      }
    },
    selectAny() {
      this.selectedProductFree = []
      this.selectedProductFree.unshift({
        product_id: this.conditions.discount_items[0].product_id,
        uom_id: this.conditions.discount_items[0].uom_id,
        quantity: this.conditions.discount_items[0].quantity
      })
    },
    handleOk(e) {
      this.selectedProductFree.forEach(el => {
        let var_product = this.dataSend.products
          .filter(
            p =>
              p.product_id == el.product_id &&
              p.uom_id == el.uom_id &&
              p.unit_price == 0 &&
              p.promo_type_id == el.promo_type_id
          )
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(var_product)) {
          var_product.quantity += el.quantity
          var product = this.$store.state.martSale.order.products.find(
            p => p.product_id == el.product_id
          )
          var_product.available_quantity = product.current_stock
          //move to index 0
          this.arraymove(this.dataSend.products, this.dataSend.products.indexOf(var_product), 0)
        } else {
          var product = this.$store.state.martSale.order.products.find(
            p => p.product_id == el.product_id
          )
          this.item.available_quantity = product.current_stock
          this.item.product_id = el.product_id
          this.item.uom_id = el.uom_id
          this.item.quantity = el.quantity
          this.item.unit_price = 0
          this.item.discount_rate = 0
          this.item.promo_type_id = this.promotion_free_item_per_amount.promo_type_id
          this.item.remarks = this.promotion_free_item_per_amount.promotion_name
          this.item.promo_free_item_cond_id = this.conditions.promo_free_item_cond_id
          this.dataSend.products.unshift(_.clone(this.item))
        }
      })
      this.showChooseFreeItems = false
      this.visible = false
    },
    handleCancel(e) {
      this.visible = false
    },
    removeFreeItemPerAmount() {
      this.promotion_free_item_per_amount = this.getPromotionFreeItemPerAmount(
        this.dataSend.sub_total
      )
      if (this.promotion_free_item_per_amount) {
        let checkExists = this.dataSend.products
          .filter(
            p =>
              p.promo_free_item_cond_id !=
                this.promotion_free_item_per_amount.conditions
                  .promo_free_item_cond_id &&
              p.promo_free_item_cond_id != null &&
              p.promo_type_id ==
                this.promotion_free_item_per_amount.promo_type_id &&
              p.unit_price == 0
          )
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(checkExists)) {
          this.dataSend.products.splice(
            this.dataSend.products.indexOf(checkExists),
            1
          )
          this.showChooseFreeItems = true
        }
      } else {
        let checkExists = this.dataSend.products
          .filter(p => p.promo_free_item_cond_id != null && p.unit_price == 0)
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(checkExists)) {
          this.dataSend.products.splice(
            this.dataSend.products.indexOf(checkExists),
            1
          )
          this.showChooseFreeItems = true
        }
      }
    },
    clearInput() {
      this.dataSend = {
        stock_out_id: null,
        counter_id: parseInt(localStorage.getItem('counterId')),
        order_no: null,
        customer_id: null,
        sub_total: null,
        discount: null,
        total_after_discount: null,
        vat_amount: null,
        vat_rate: null,
        grand_total: null,
        fx_rate: null,
        remark: null,
        paid_in_riel: null,
        paid_in_usd: null,
        change_in_riel: null,
        change_in_usd: null,
        paid_in_coupon: null,
        paid_in_credit_card: null,
        products: []
      }
      ;(this.selected_order = ''), (this.orderSelected = {})
      this.$store.commit('martSale/order/SET_SELECTED_ORDER_HISTORIES', {})

      this.itemAddon = []
    },
    backHome() {
      PageOptions.pageEmpty = false
      this.$router.push('/')
    },
    callback(val) {
      // console.log(val)
    },
    showBillForm() {
      this.promotion_free_item_per_amount = this.getPromotionFreeItemPerAmount(
        this.dataSend.sub_total
      )
      if (this.promotion_free_item_per_amount && this.showChooseFreeItems) {
        this.conditions = this.promotion_free_item_per_amount.conditions
        if (this.conditions.free_status == 'All') {
          this.selectAll(true)
        } else {
          this.selectAny()
        }
        this.visible = true
        return
      }

      this.$bvModal.show('modalCheckBill')
    },
    closeForm() {
      this.showForm = false
    },
    receiptPreview() {
      this.showPreviewReciept = true
    },
    choseCounter() {
      if (
        localStorage.getItem('counterId') === undefined ||
        localStorage.getItem('counterId') === null ||
        localStorage.getItem('counterId') === 'undefined' ||
        localStorage.getItem('counterId') === 'null'
      ) {
        if (this.$store.state.authUser.counter.length == 1) {
          localStorage.setItem(
            'counterId',
            this.$store.state.authUser.counter[0].counter_id
          )
          return
        } else {
          this.$confirm({
            centered: true,
            zIndex: 1020,
            title: 'Which counter are you ?',
            content: h =>
              h(Counter, {
                props: {
                  value: this.counter,
                  counter: this.$store.state.authUser.counter
                }
              }),
            onOk: () => {
              localStorage.setItem('counterId', this.counter.counter_id)
              this.$destroyAll()
            },
            onCancel: () => {
              this.$destroyAll()
              this.$router.push('/')
            }
          })
        }
      }
    },
    searchProduct() {
      this.products = this.$store.state.martSale.order.products
        .filter(
          p =>
            p.barcode
              .toLowerCase()
              .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
            p.product_name_en
              .toLowerCase()
              .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
            (p.product_name_kh
              ? p.product_name_kh
                  .toLowerCase()
                  .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1
              : null)
        )
        .splice(0, 20)
    },
    arraymove(arr, fromIndex, toIndex) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    },
    changeLanguage(language) {
      this.$root.$i18n.locale = language.code
    },
    compareObject(collection1, collection2) {
      const contains = (arr, obj) => {
        let i = arr.length
        while (i--) {
          let product1 = arr[i]
          let product2 = obj
          if (
            product1.product_id === product2.product_id &&
            product1.quantity === product2.quantity
          ) {
            return true
          }
        }
        return false
      }

      const isEqual = (obj1, obj2) => {
        let n = 0
        if (obj1.length !== obj2.length) {
          return false
        }
        for (let i = 0; i < obj1.length; i++) {
          if (contains(obj2, obj1[i])) {
            n++
          }
        }
        return n === obj1.length
      }
      return isEqual(collection1, collection2)
    }
  },
  watch: {
    dataSend: {
      handler() {
        this.calculate()
      },
      deep: true
    },
    activeKey: function(val) {
      this.pro_group_id = val
      this.onChangeSubCategory(val)
    },
    activeKeyCategory: function(val) {
      this.category_id = val
      this.onChangeMainCategory(val)
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    },
    'fetchOptions.search_value': debounce(function(search) {
      if (search) {
        this.searchProduct()
      } else {
        this.onChangeCategory(this.category_id)
        if (this.pro_group_id) {
          this.onChangeSubCategory(this.pro_group_id)
        }
      }
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    next()
  }
}
</script>
<style scoped>
.pos-product-img .img {
  object-fit: cover;
  width: 100%;
}
.pos-product-thumb .img {
  object-fit: cover;
  width: 100%;
}
.pos-customer .pos-sidebar .pos-sidebar-body .pos-table {
  padding: 0 10px;
}
.pos-customer .pos-sidebar .pos-sidebar-body .pos-table .pos-table-row {
  padding: 10px 0;
}
.form-group {
  margin-bottom: 0.3rem;
}
.border-bottom {
  border-bottom: 1px solid #74b1f1 !important;
}
.pos-customer .pos-menu .logo {
  padding: 12px;
}
.pos-customer .pos-menu .logo .logo-img {
  text-align: center;
  height: 105px;
}
.nav-container {
  top: 2;
  background: #f2f3f4;
  color: #5b6166;
}
.pos-sidebar-footer {
  background: #495057 !important;
  color: #f8f9fa;
  position: relative;
  padding: 10px 25px;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  -webkit-box-shadow: 0 -1px rgba(52, 58, 64, 0.1);
  box-shadow: 0 -1px rgba(52, 58, 64, 0.1);
}
.pos-customer .pos-sidebar .pos-sidebar-footer .btn-row {
  padding: 10px;
  margin: 0 -25px -10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.pos-customer .pos-sidebar .pos-sidebar-footer .btn-row .btn {
  border-radius: 10px !important;
}
.form-control-lg {
  background: #f2f3f4;
  color: #5b6166;
}
.pos-customer .pos-menu .nav.nav-tabs {
  margin-top: 8px;
}
.time {
  font-family: 'Times New Roman', serif;
  font-weight: bold;
  font-size: 28px;
  text-transform: uppercase;
  line-height: 1;
  text-align: center;
  background: linear-gradient(
    90deg,
    rgba(186, 148, 62, 1) 0%,
    rgba(236, 172, 32, 1) 20%,
    rgba(186, 148, 62, 1) 39%,
    rgb(250, 242, 125) 50%,
    rgba(186, 148, 62, 1) 60%,
    rgba(236, 172, 32, 1) 80%,
    rgba(186, 148, 62, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 3s infinite;
  background-size: 200%;
  background-position: left;
}
@keyframes shine {
  to {
    background-position: right;
  }
}
.vgt-global-search {
  padding: 2px;
}
.ant-modal-body {
  padding: 4px;
}
.tag-container {
  color: #fff;
  position: absolute;
  z-index: 3;
  top: 22px;
  left: 0;
  line-height: 18px;
  font-size: 0.6rem;
  font-weight: 600;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-flow: column nowrap;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-align: start;
  -webkit-align-items: center;
  -ms-flex-align: start;
  align-items: center;
  text-transform: uppercase;
}
.tag-container .multi-tag {
  background-color: #d70f64eb;
  padding: 0 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-align-self: center;
  -ms-flex-item-align: center;
  align-self: center;
  max-width: 232px;
  border-radius: 2px;
}
.search-box {
  padding: 12px 12px;
  background: #6c757d;
  color: #ffffff;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
}
.in-stock-container {
  color: #fff;
  position: absolute;
  z-index: 3;
  top: 113px;
  right: 0;
  line-height: 18px;
  font-size: 0.6rem;
  font-weight: 600;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-flow: column nowrap;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-align: start;
  -webkit-align-items: center;
  -ms-flex-align: start;
  align-items: center;
}
.in-stock-container .in-stock-card {
  background-color: #0f7a77b5;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-align-self: center;
  -ms-flex-item-align: start;
  align-self: center;
  max-width: 232px;
  border-radius: 2px;
}
.pos-customer .pos-sidebar .pos-sidebar-header {
  padding: 16px 12px !important;
  background: #495057;
  color: #495057;
}
.pos-customer .pos-sidebar .pos-sidebar-header .order {
  background: #00acac;
  padding: 2px 6px;
}
hr {
  margin: 0.9375rem 0;
  color: #adb5bd;
  border: 0;
  opacity: 0.4;
}
.pos-customer .pos-content {
  overflow-y: auto;
  overflow-x: hidden;
}
@media (max-width: 991.98px){
  .pos-customer .pos-menu .logo, .pos-sidebar-footer-time {
    display: none;
  }
  .pos-customer .pos-content .sub-group {
    top: 25px;
  }
  .pos-customer .pos-sidebar .pos-sidebar-header .back-btn {
    margin-left: 10px;
  }
}
</style>
